var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import * as actions from '../constants';
var initialState = {};
export var authorisation = function authorisation() {
  var _extends2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'ORGANISATION_ACCESS_SUCCESS':
      return _extends({}, state, (_extends2 = {}, _extends2[action.organisationId] = _extends({}, action.payload, {
        permission: action.permission
      }), _extends2));

    case actions.LOG_OUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};